export const DLP_DETAILS_TAB_ID = "DLP-Details";
export const DLP_ATTACHMENTS_TAB_ID = "DLP-attachments";
